module.exports = __webpack_public_path__ + "05_short_gold.6bac4e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_short_gold.png
// module id = Te9e
// module chunks = 0